import React from 'react';
import NavBar from './navbar';

const Header = () => {
    return (
        <div className="container">
            <NavBar />
        </div>
    )
}

export default Header;